import React, { useEffect, useState, useRef } from 'react'
import ExcelExport from '../ExcelExport'
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from '../Sidebar';
// import env from 'react-dotenv'
const ModalCustom = ({email, message, interest,})=>{
 return(
  <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel">Message</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>{email}</p>
        <p>{interest}</p>
        <p>{message}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
 )
}


export default function ContactTable() {

    const [prices, setPrices] = useState([])
    
     //Pagination
    const [page, setPage] = useState(1)
    const [postsPerPage, setPostsPerPage] = useState(20)
    const getPrices = async ()=> {
        const token = sessionStorage.getItem('token')
        const response = await fetch(`${process.env.REACT_APP_API_URL}/contact/get-messages`,{
          headers: {
            'x-access-token': token
          }
        })
        const pricelist = await response.json()
        pricelist.sort((a, b) => {
          const dateA = new Date(a.date);
          const dateB = new Date(b.date);
          return dateB - dateA;
        });
        setPrices(pricelist)
       // console.log(prices)
    }

    const totalPages = Math.ceil(prices.length / postsPerPage);
    const pageRange = 10; // Number of page buttons to show at a time

    const startPage = Math.max(1, page - Math.floor(pageRange / 2));
    const endPage = Math.min(totalPages, startPage + pageRange - 1);

    const pageButtons = [...Array(endPage - startPage + 1)].map((_, i) => startPage + i);
    useEffect(()=>{
        getPrices()
    }, [])

    
    const lastPostIndex = page*postsPerPage
    const firstPostIndex = lastPostIndex - postsPerPage
    const currentPrices = prices.slice(firstPostIndex, lastPostIndex)
    const selectPageHandler =(selectedPage)=>{
      setPage(selectedPage)
    }

    const showModal = (e, m, i) =>{
      <ModalCustom email={e} message={m} interest={i}></ModalCustom>
    }
    

    //The Delete Button
    const handleDelete = async (itemId) =>{
      const fL = prices.filter((filteredPrice) => filteredPrice._id !== itemId)
      const token = sessionStorage.getItem('token')
      await fetch(`${process.env.REACT_APP_API_URL}/delete-contact/${itemId}`,{
          method:'DELETE',
          headers: {
              'Content-Type':'application/json',
              'x-access-token':token
          }
      })
        // .then(console.log("Delete successfull"))
    setPrices(fL)
  }

  
  //edit page
  const navigate = useNavigate()
  
  return (
    <>
        <div className="sidebar">
    <Sidebar/>
    <h2 id='tabler'>Contact Us</h2>
    </div>
   
        <div id='tabler1'>

          
          {/* <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h1>KCA Spot Rate</h1>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'right' }}>
        <div style={{ marginBottom: '10px', padding:"30px 30px 30px 30px"}}>
          <ExcelExport excelData={prices} fileName={'PricesSheet'} />
        </div>
        <div style={{ marginBottom: '10px', padding:"30px 10px 30px 10px"}}>
        <Link to='/kca-spot-rate-form'> <button type="button" class="btn btn-secondary">  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-square-fill" viewBox="0 0 16 16">
  <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z"/>
</svg>   Create New</button></Link>
        </div> 
        </div>
          
             
      </div>   */}

      <table class="table" id="table1">

  <thead>
    <tr>
      <th scope="col">Date</th>
      <th scope="col">Interest</th>
      <th scope="col">Name</th>
      <th scope='col'>Company</th>
      <th scope="col">Phone</th>
      <th scope="col">Email</th>
      <th scope='col'>Delete</th>
      <th scope="col">View</th>
      {/* <th scope="col">Loosing</th>
      <th scope="col">Gaining</th>
      <th scope="col">Crop</th> */}
    </tr>
  </thead>

  <tbody>

 {currentPrices && currentPrices.map((price, index) =>(
<tr key={price._id}>
 <td>{new Date(price.date).toLocaleDateString('en-US')}</td>
<td>{price.interest}</td>
                <td>{price.name}</td>
<td>{price.company}</td>
<td>{price.phone}</td>
<td>{price.email}</td>
<td><button type="button" class="btn btn-danger" onClick={()=>handleDelete(price._id)}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16"><path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"/> <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z"/></svg></button></td>
<td><button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target={`#exampleModal${index}`} >
 View
</button>

<div class="modal fade" id={`exampleModal${index}`}  tabindex="-1" aria-labelledby={`exampleModalLabel${index}`}  aria-hidden="true">
<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
<div class="modal-content">
 <div class="modal-header">
<h1 class="modal-title fs-5" id="exampleModalLabel">Message</h1>
<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
</div>
<div class="modal-body">
<p><b>Email: </b>{price.email}</p>
<p><b>Interest: </b>{price.interest}</p>
<p><b>Message: </b>{price.message}</p>
</div>
<div class="modal-footer">
<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
</div>
</div>
</div>
</div>

</td>
</tr>
))}
</tbody>
  

  
</table>


{currentPrices.length > 0 && (
  <div className="pagination">
    <br />
    {pageButtons.map((pageNumber) => (
      <button
        type="button"
        id="num-but"
        class="btn btn-secondary btn-lg mb-2"
        onClick={() => selectPageHandler(pageNumber)}
        key={pageNumber}
      >
        {pageNumber}
      </button>
    ))}
    <br />
    {/**Fixing the date issue */}
  </div>
)}
{!prices && <div class="alert alert-primary" role="alert">
  Oops! Something went wrong.
</div>}


    </div>
    

    </>
    
  )


  
}


